// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1sYGO","buttons":"PendingPaymentAlert_buttons__1FWNc"};